import { useEffect, useRef, useState } from 'react';
import { HTML_DRAFT_INTERVAL_MS } from '@/lib/htmlDraftPreviewPolicy';

export default function useStreamingHtmlDraft(html, prepare) {
  const latest = useRef(html);
  latest.current = html;
  const last = useRef(html);
  const timer = useRef(null);
  const [draft, setDraft] = useState(() => prepare(html));
  useEffect(() => {
    if (timer.current !== null || html === last.current) return;
    // Continuous tokens must still paint: throttle rather than debounce.
    timer.current = setTimeout(() => {
      timer.current = null;
      last.current = latest.current;
      setDraft(prepare(latest.current));
    }, HTML_DRAFT_INTERVAL_MS);
  }, [html, prepare]);
  useEffect(() => () => {
    clearTimeout(timer.current);
    timer.current = null;
  }, []);
  return draft;
}
